export const NOTIFICATIONS_HOME = "/notifications";

export const linkTo = {
  notifications: () => NOTIFICATIONS_HOME,
};
